export const SEO_CATEGORY_MAP = {
  'NA==': true,
  'Ng==': true,
  'Nw==': true,
  'OA==': true,
  'MTI=': true,
  'MTM=': true,
  'MTQ=': true,
  'MTY=': true,
  'NDU=': true,
  'NTQ=': true,
  'Njk=': true,
  'ODI=': true,
  'OTQ=': true,
  'OTk=': true,
  MTEx: true,
  MTY3: true,
  MTcy: true,
  MjQx: true,
  MjQy: true,
  MjQz: true,
  MjQ0: true,
  MjQ1: true,
  MjQ2: true,
  MjQ3: true,
  MjQ4: true,
  MjQ5: true,
  MjUz: true,
  MjU0: true,
  MjU1: true,
  MjU2: true,
  MjY2: true,
  MjY1: true,
  MjY3: true,
};
